import { areCustomersEqual, PaymentCustomer } from '../domain/customer.entity';

export interface ValidateCustomersRequest {
    customers: PaymentCustomer[];
}

export interface ValidateCustomersResponse {
    areAllEqual: boolean;
    validationErrors: string[];
}

export class ValidateCustomersUseCase {
    async execute(request: ValidateCustomersRequest): Promise<ValidateCustomersResponse> {
        const { customers } = request;
        
        if (!customers || customers.length === 0) {
            return {
                areAllEqual: true,
                validationErrors: []
            };
        }

        // Verificar se todos os customers são iguais
        const areAllEqual = customers.every(customer => 
            areCustomersEqual(customer, customers[0])
        );

        // Gerar erros de validação para debug
        const validationErrors: string[] = [];
        
        if (!areAllEqual && customers.length > 1) {
            validationErrors.push('Os customers selecionados não são iguais');
        }

        return {
            areAllEqual,
            validationErrors
        };
    }
}
